import { Selector } from "@rhumbix/rmbx_design_system_web"
import { useImperativeHandle, useState, forwardRef, FunctionComponent, useEffect, useRef } from "react"
import { tSelectorOption } from "../../../SelectorV3/types"
import { ICellEditorParams } from "ag-grid-community"
import { colorStyles } from "../../../SelectorV3/styles"

type tProps = ICellEditorParams & {
    value: string
    disableOptions: string[]
    values: string[]
    rowIndex: number
    fixedOptions: string[]
}

const SingleChoiceCellEditor: FunctionComponent<tProps> = forwardRef((props: tProps, ref) => {
    const [currentValue, setCurrentValue] = useState(props.value)
    const [searchValue, setSearchValue] = useState("")
    const [currentOptions, setCurrentOptions] = useState(props.values.map(ea => ({ label: ea, value: ea })))
    const [previousValue, setPreviousValue] = useState(props.value)

    // This is required to have the cell editor pop out of the cell when the contents are too large for the cell
    useImperativeHandle(ref, () => {
        return {
            getValue: () => currentValue,
        }
    })
    const refInput = useRef<HTMLDivElement>(null)

    useEffect(() => {
        refInput?.current?.focus()
    }, [])

    useEffect(() => {
        if (previousValue !== currentValue) {
            props.api.stopEditing()
            props.api.setFocusedCell(props.rowIndex, props.column.getColId())
            setPreviousValue(currentValue)
        }
    }, [currentValue])

    const handleChange = (selectedValue: tSelectorOption | null) => {
        setCurrentValue(selectedValue?.value)
    }
    const styles = {
        ...colorStyles,
        indicatorSeparator: (styles: React.CSSProperties) => {
            return {
                ...styles,
                marginTop: 8,
                marginBottom: 8,
            }
        },
    }

    const handleInputChange = (value: string) => {
        setSearchValue(value)
        setCurrentOptions(
            props.values
                .filter(ea => ea.toLowerCase().includes(value.toLowerCase()))
                .map(ea => ({ label: ea, value: ea }))
        )
    }

    return (
        <div className="single-choice-editor" id={`single-choice-editor-${props.rowIndex}`}>
            <Selector
                isClearable={true}
                innerRef={refInput}
                inputValue={searchValue}
                isMulti={false}
                isDisabled={false}
                onChange={handleChange}
                onInputChange={handleInputChange}
                openMenuOnFocus={true}
                options={currentOptions}
                initialSelectedOption={{ label: currentValue, value: currentValue }}
                styles={styles}
            />
        </div>
    )
})

export default SingleChoiceCellEditor
